// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ddd0f9fe","239":"3bb2830e","453":"13437cd1","667":"7d9a9bbc"}[chunkId] + ".chunk.js";
};